// extracted by mini-css-extract-plugin
module.exports = {"form":"NewCommentForm_form__1nl_e","loading":"NewCommentForm_loading__3o8Im","control":"NewCommentForm_control__2-_FS","actions":"NewCommentForm_actions__28bu-"};